import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TooltipText from "../../../../../../components/TooltipText/TooltipText";

export default function TemarioCursoComprado({
  cursoData,
  numerador,
  denominador,
}) {
  console.log(cursoData.detail.datos);
  const updateLessonStates = (secciones) => {
    let inProgressSet = false; // Flag to mark if "en curso" has been assigned
    secciones.forEach((seccion) => {
      seccion.lecciones.forEach((leccion) => {
        if (leccion.terminado) {
          leccion.estado = "terminado";
        } else if (!inProgressSet) {
          leccion.estado = "en curso";
          inProgressSet = true; // Mark that "en curso" has been assigned
        } else {
          leccion.estado = "sin empezar";
        }
      });
    });
  };

  useEffect(() => {
    console.log(cursoData.detail.datos.CURSO_TEMARIO.secciones);
  }, [cursoData]);

  const navigate = useNavigate();
  const location = useLocation();

  const cambiarLeccionId = (nuevoId) => {
    // Crea una instancia de URLSearchParams con los parámetros actuales
    const searchParams = new URLSearchParams(location.search);
    // Establece el nuevo valor para "leccion_id"
    searchParams.set("leccion_id", nuevoId);
    // Actualiza la URL sin recargar la página `?f=cc&curso_id=${curso.curso_id}&leccion_id=${curso.ultima_leccion.leccion_id}`
    navigate(`${location.pathname}?${searchParams.toString()}`);
    window.location.reload();
  };

  const totalLineas = cursoData.detail.datos.CURSO_TEMARIO.lineas_totales;
  const lineasPintadas =
    cursoData.detail.datos.CURSO_TEMARIO.lineas_completadas;

  // Call the method to update lesson states
  updateLessonStates(cursoData.detail.datos.CURSO_TEMARIO.secciones);

  const mSeleccionarIcono = (vEstado) => {
    switch (vEstado) {
      case "terminado":
        return (
          <>
            <i
              className="fi fi-rs-check-circle"
              style={{ color: "#A5FF32" }}
            ></i>
            <i class="fi fi-rr-play-alt" style={{ color: "white" }}></i>
          </>
        );
      case "en curso":
        return (
          <>
            <i className="fi fi-sr-loading" style={{ color: "#1DE8F5" }}></i>
            <i class="fi fi-rr-play-alt" style={{ color: "white" }}></i>
          </>
        );
      default:
        return (
          <>
            <i className="fi fi-rr-circle" style={{ color: "#707585" }}></i>
            <i class="fi fi-rr-play-alt" style={{ color: "#707585" }}></i>
          </>
        );
    }
  };

  return (
    <>
      <div className="titulo-temario">
        <div className="temario-titulo-2">
          <i class="fi fi-rr-book-alt libro-alternativo-6"></i>
          <p className="temario-titulo-texto">Temario</p>
        </div>
        <div className="frame-290172">
          <div className="frame-290171">
            <div className="frame-290170">
              <p className="_2">{numerador}</p>
              <p className="_19">{`/${denominador}`}</p>
            </div>
            <p className="completadas">completadas</p>
          </div>
          {/* Mapeo dinámico de líneas de progreso por sección */}
          <div className="frame-290166">
            {Array.from({ length: totalLineas }, (_, index) => (
              <div
                key={index}
                className={
                  index < lineasPintadas ? "frame-290163" : "frame-290164"
                }
              ></div>
            ))}
          </div>
        </div>
      </div>
      <div className="temario-info">
        {cursoData.detail.datos.CURSO_TEMARIO.secciones.map(
          (seccion, index) => (
            <>
              <div className="temario-info-titulo">
                <p className="temario-info-titulo-1">
                  {seccion.titulo_seccion}
                </p>
                <p className="temario-info-titulo-2">
                  {seccion.total_lecciones} lecciones
                </p>
              </div>
              {seccion.lecciones.map((leccion) => (
                <TooltipText
                  positionType="custom" // Adjust placement as needed
                  customOffset={7} // Adjust offset as needed
                  vText={
                    leccion.estado === "terminado"
                      ? "Lección terminada"
                      : leccion.estado === "en curso"
                      ? "Lección en curso"
                      : "Debes completar la lección anterior"
                  }
                  key={leccion.leccion_id}
                  className={
                    leccion.estado === "terminado" ||
                    leccion.estado === "en curso"
                      ? "temario-leccion-1"
                      : "temario-leccion-4"
                  }
                  onClick={() =>
                    leccion.estado === "terminado" ||
                    leccion.estado === "en curso"
                      ? cambiarLeccionId(leccion.leccion_id)
                      : null
                  }
                >
                  {mSeleccionarIcono(leccion.estado)}
                  <div className="temario-leccion-4-info">
                    <div className="temario-leccion-titulo-gris">
                      <p
                        className={
                          leccion.estado === "terminado" ||
                          leccion.estado === "en curso"
                            ? "temario-leccion-titulo-texto"
                            : "temario-leccion-titulo-texto-2"
                        }
                      >
                        {leccion.leccion_nombre}
                      </p>
                    </div>
                  </div>
                </TooltipText>
              ))}

              {index <
                cursoData.detail.datos.CURSO_TEMARIO.secciones.length - 1 && (
                <div className="linea-curso-comrpadop-h"></div>
              )}
            </>
          )
        )}
      </div>
    </>
  );
}
